import { useApiStore } from "@/stores/apiStore";

export const getEndpoints = () => {
  const apiStore = useApiStore();
  const apiUrl = apiStore.apiUrl;

  return {
    // Sesion
    checkToken: apiUrl + "/api/auth/tokenValido/",
    login: apiUrl + "/api/auth/login",
    loginPin: apiUrl + "/api/auth/logintarjeta",
    loginCliente: "/api/auth/logincliente",
    restorePassword: apiUrl + "/api/auth/RestablecerPassword",
    passwordUpdating: apiUrl + "/api/auth/updatepassword",
    logout: apiUrl + "/api/auth/logout",

    // PWA
    pushSubscribe: apiUrl + "/api/push/subscribe",
    pushUnsubscribe: apiUrl + "/api/push/unsubscribe",
    pushVapidPublicKey: apiUrl + "/api/push/vapid-public-key",

    // Tablas
    customGrid: apiUrl + "/api/grid/save/",

    // Ordenes de trabajo
    employees: apiUrl + "/api/empleado/agenda",
    customers: apiUrl + "/api/cliente/busqueda",
    customersAddresses: apiUrl + "/api/cliente/direccion/busqueda",
    listTypes: apiUrl + "/api/inttipo",
    listModes: apiUrl + "/api/intmodo",
    newEvent: apiUrl + "/api/agenda/evento/crear",
    customerWorks: apiUrl + "/api/obra/evento/bycliente",
    customerMachines: apiUrl + "/api/maquina/bycliente",
    workOrders: apiUrl + "/api/reparacion/byobra",
    workPhases: apiUrl + "/api/tipofase",
    workItems: apiUrl + "/api/obralpartida/byobra",

    // Gerencia
    managementMenu: apiUrl + "/api/gerencia/menu",
    managementView: apiUrl + "/api/gerencia/view/initial",
    managementFilterData: apiUrl + "/api/gerencia/view/data",
    managementWidgetDetail: apiUrl + "/api/gerencia/view/detail",

    // Pedidos / B2B
    catalogData: apiUrl + "/api/paginawebcategoria/catalogo",
    openOrder: apiUrl + "/api/pedidoweb/abierto",
    addLineToOrder: apiUrl + "/api/pedidoweb/addlinea",
    modifyQuantity: apiUrl + "/api/pedidoweb/cambiarcantidad",
    observations: apiUrl + "/api/pedidoweb/observaciones",
    deleteLine: apiUrl + "/api/pedidoweb/dellinea",
    deleteOrder: apiUrl + "/api/pedidoweb/borrar",
    createNewOrder: apiUrl + "/api/pedidoweb/confirmar",
  };
};
